<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>团体邀请</h3>
        <span>申请截止时间：2023年09月30日</span>
      </div>

      <div class="main">
        <!--提示-->
        <div class="point">
          <div class="title">
            重要提醒
          </div>
          <div class="content">
            为切实保障参观观众和参展企业的健康安全工作，提供安全、有序的参展环境，主办方将严格落实《国务院联防联控机制要求》和《北京会展行业新馆肺炎防控指 <br/>
            南》的相关规定，对于全体参展/参观人员采用展前“预约参观+实名认证”流程，及现场刷“实体身份证原件”的形式入场。
          </div>
        </div>

        <!--搜索框-->
        <div class="item">
          <div class="search">
            <el-input
                v-model="search"
                clearable
                placeholder="请输入姓名/公司名">
            </el-input>
            <el-button class="btn" @click="searchMember">搜 索</el-button>
          </div>
          <el-button class="addmember btn" @click="add">新增买家</el-button>
        </div>

        <!--表格-->
        <div class="tab">
          <el-table
              :cell-style="{padding:'0px'}"
              :data="tableData"
              :header-cell-style="setSellStyle"
              :row-style="{height:'64px',color:'#333333'}"
              stripe
              style="width: 100%">
            <el-table-column
                label="多选"
                type="selection"
                width="54"
            ></el-table-column>
            <el-table-column
                label="姓名"
                prop="name"
                width="54"
            ></el-table-column>
            <el-table-column
                label="公司"
                prop="companyName"
                width="210"
            ></el-table-column>
            <el-table-column
                label="公司地址"
                prop="companyAddress"
                width="210"
            ></el-table-column>
            <el-table-column
                label="手机"
                prop="tel"
            ></el-table-column>
            <el-table-column
                label="证件类型"
                prop="idType"
                width="120"
            ></el-table-column>
            <el-table-column
                label="证件号码"
                prop="Id"
            ></el-table-column>
            <el-table-column
                label="部门/职责"
                prop="position"
                width="100"
            ></el-table-column>
            <el-table-column
                label="邮箱"
                prop="email"
            ></el-table-column>
            <el-table-column
                label="状态"
                prop="status"
                width="80"
            >
              <template slot-scope="scope">
                <span v-show="!scope.row.status" style="color: red">未通过</span>
                <span v-show="scope.row.status">已通过</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                    class="edit"
                    type="text"
                    @click="openEdit(scope.row, scope.$index)"
                ><i class="el-icon-edit-outline">编辑</i></el-button
                >
                <el-button type="text" @click="deletMsg(scope.$index)"
                ><i class="el-icon-delete">删除</i></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="download">
          <div class="item">
            <p>
              如设贵公司参展人员较多，请<span class="template"
            ><a href="#">点击此处下载人员名单模板</a></span
            >
            </p>
            <p>
              <el-upload
                  class="upload-demo"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
              >
                <el-button class="upload">上传文件</el-button>
              </el-upload>
            </p>
          </div>
          <div class="">
            <el-button class="btn submit">提交</el-button>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 新增弹框开始 -->
    <div class="editMsg">
      <el-dialog
          :visible.sync="saveVisible"
          center
          width="30%"
          @close="closeEdit('saveContent')">
        <span slot="title" class="dialog-footer"> 新增参展人员信息 </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form ref="saveContent" :model="saveContent" label-position="top">
              <el-form-item
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  label="姓名："
                  prop="name"
              >
                <el-input
                    v-model="saveContent.name"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入姓名"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="单位名称："
                  prop="companyName"
              >
                <el-input
                    v-model="saveContent.companyName"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入单位名称"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="单位地址："
                  prop="companyAddress"
              >
                <el-input
                    v-model="saveContent.companyAddress"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入单位名称"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '证件类型不能为空' }]"
                  label="证件类型："
                  prop="idType"
              >
                <el-select v-model="saveContent.idType" placeholder="请选择证件类型">
                  <el-option label="身份证" value="身份证"></el-option>
                  <el-option label="军官证" value="军官证"></el-option>
                  <el-option label="护照" value="护照"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '证件号码不能为空' }]"
                  label="证件号码："
                  prop="Id">
                <el-input
                    v-model="saveContent.Id"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入证件号码"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item label="职务：" prop="position">
                <el-input
                    v-model="saveContent.position"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入职务"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '手机号码不能为空' }]"
                  label="手机："
                  prop="tel"
              >
                <el-input
                    v-model="saveContent.tel"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入手机"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                    v-model="saveContent.email"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入E-mail"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-row class="save"
              >
                <el-button @click="sumitAdd()">保存</el-button>
              </el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>

    <!-- 编辑弹框开始 -->
    <div class="editMsg">
      <el-dialog
          ref="editdialog"
          :visible.sync="editVisible"
          center
          width="30%"
          @close="closeEdit('editContent')">
        <span slot="title" class="dialog-footer"> 编辑参展人员信息 </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form ref="editContent" :model="editContent" label-width="124px">
              <el-form-item
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  label="姓名："
                  prop="name"
              >
                <el-input
                    v-model="editContent.name"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入姓名"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="单位名称："
                  prop="companyName"
              >
                <el-input
                    v-model="editContent.companyName"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入单位名称"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="单位地址："
                  prop="companyAddress"
              >
                <el-input
                    v-model="editContent.companyAddress"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入单位名称"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '证件类型不能为空' }]"
                  label="证件类型："
                  prop="idType"
              >
                <el-select v-model="editContent.idType" placeholder="请选择证件类型">
                  <el-option label="身份证" value="身份证"></el-option>
                  <el-option label="军官证" value="军官证"></el-option>
                  <el-option label="护照" value="护照"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '证件号码不能为空' }]"
                  label="证件号码："
                  prop="Id">
                <el-input
                    v-model="editContent.Id"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入证件号码"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item label="职务：" prop="position">
                <el-input
                    v-model="editContent.position"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入职务"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :rules="[{ required: true, message: '手机号码不能为空' }]"
                  label="手机："
                  prop="tel"
              >
                <el-input
                    v-model="editContent.tel"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入手机"
                    type="age"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                    v-model="editContent.email"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="请输入E-mail"
                    type="age"
                ></el-input>
              </el-form-item>
              <el-row class="save"
              >
                <el-button @click="saveMsg()">保存</el-button>
              </el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 编辑弹框结束 -->

  </div>
</template>

<script>
export default {
  name: "groupInvite",
  created() {
    this.init();
  },
  data() {
    return {
      search: '',     //搜索框
      //表格数据
      tableData: [
        {
          name: "张三",
          companyName: "中国煤炭工业国际技术咨询有限责任公司",
          companyAddress: "北京市海淀五路居和园街道",
          tel: "13812345678",
          idType: "身份证",
          Id: "10134319904145611",
          position: "会展部经理",
          email: "224455667@qq.com",
          status: 0,
        },
        {
          name: "李四",
          companyName: "中国煤炭工业国际技术咨询有限责任公司",
          companyAddress: "北京市海淀五路居和园街道",
          tel: "13812345678",
          idType: "身份证",
          Id: "10134319904145611",
          position: "会展部经理",
          email: "7788995423@qq.com",
          status: 1,
        },
      ],

      //编辑弹框标志位
      editVisible: false,
      //编辑弹框的具体内容
      editContent: {
        name: "",
        companyName: "",
        companyAddress: "",
        tel: "",
        idType: "",
        Id: "",
        position: "",
        email: "",
      },
      //保存弹框的具体内容
      saveVisible: false,
      //保存弹框的具体内容
      saveContent: {
        name: "",
        companyName: "",
        companyAddress: "",
        tel: "",
        idType: "",
        Id: "",
        position: "",
        email: "",
      },
    }
  },
  methods: {
    //搜索
    searchMember() {
      console.log(this.search)
    },
    //打开新增弹框
    add() {
      this.saveContent = {};
      this.saveVisible = true;
    },
    //保存
    sumitAdd() {
      this.$refs['saveContent'].resetFields();
      this.saveVisible = false;
    },

    //编辑弹框相关函数
    //打开编辑框
    openEdit(row, index) {
      this.editContent = row;
      this.editVisible = true;
      console.log(index);
    },
    //取消关闭编辑框
    closeEdit(formRef) {
      this.$refs[formRef].resetFields();
      this.editVisible = false;
    },
    //编辑保存函数
    saveMsg() {
      this.editVisible = false;
    },
    //表格数据删除
    deletMsg(index) {
      this.tableData.splice(index, 1);
    },

    //文件上传移除相关钩子函数
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
          `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
              files.length + fileList.length
          } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    //表头圆角处理
    setSellStyle({row, column, rowIndex, columnIndex}) {
      if (column.label === '多选') {
        return "background:#FDC400;color:#FFF;border-top-left-radius:5px;font-weight: 500;height: 42px;padding: 0;"
      }
      if (column.label === '操作') {
        return "background:#FDC400;color:#FFF;border-top-right-radius:5px;font-weight: 500;height: 42px;padding: 0;"
      } else {
        return "background:#FDC400;color:#FFF;font-weight: 500;height: 42px;padding: 0;"
      }
    },

    init() {
      //获取邀请列表数据
      console.log('获取邀请列表数据');
    }
  }

}
</script>

<style lang='scss' scoped>
.body {
  margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    align-items: center;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 20px;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 20px 30px 0;
    //display: flex;

    //提示
    .point {
      width: 100%;
      height: 96px;
      background: #F6F6F7;
      padding: 10px 30px;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-weight: 400;
        color: #FF190C;
        line-height: 22px;
      }

      .content {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 10px;
      }
    }

    //搜索及新增
    .item {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      //输入框
      .search {
        display: flex;
      }

      .addmember {
        background-color: #FFFFFF;
        color: #666666;
      }
    }

    //表格
    .tab {
      margin-top: 17px;
    }

    //上传
    .download {
      .item {
        margin-top: 17px;
        display: flex;
        justify-content: flex-start;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        ::v-deep .upload {
          background-color: #FFFFFF;
          color: #666666;
          height: 32px;
          padding: 0;
          font-weight: 400;
        }

        p {
          line-height: 28px;
        }
        .upload-demo {
          margin-left: 52px;
        }
        .template {
          a {
            color: #006fb8;
          }
        }
      }
    }

  }

  //弹窗
  .editMsg {
    //编辑框的弹框信息
    .dialog-footer {
      width: 100%;
      position: relative;
      top: -5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      //标题
      .instance {
        margin: 0px 17px 0px 17px;
      }
    }
  }
}


</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
}

>>> .btn.el-button {
  background-color: #006FB8;
  color: #FFFFFF;
  width: 88px;
  height: 32px;
  padding: 0;
  font-weight: 400;
  margin-left: 10px;
}

>>> .el-input {
  width: 240px;
}

>>> .el-input__inner {
  height: 32px;
  line-height: 32px;
}

>>> .el-input__icon {
  line-height: 32px;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006fb8;
  line-height: 20px;
  margin: 0px 8px;
}

.edit {
  border-right: 1px solid #e9e9e9;
}

.tab >>> .el-button {
  padding: 0px;
  border-radius: 0px;
}

.tab >>> .el-button + .el-button {
  margin-left: 0px;
}

.el-dialog__wrapper >>> .el-dialog__header {
  background: #006fb8;
}

.save {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
}

.save >>> .el-button {
  padding: 0px;
  width: 30%;
  height: 35px;
  text-align: center;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

>>> .el-dialog__close {
  color: #FFFFFF;
}

>>> .editMsg .el-input {
  width: 90%;
}

>>> .editMsg .el-select {
  width: 90%;
}

>>> .el-select .el-input {
  width: 100%;
}

>>> .upload.el-button {
  width: 103px;
}

>>> .submit.btn.el-button {
  margin: 30px 0;
}
</style>
